import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';
import { ConfirmPurchaseResponse, InitPurchaseProperties, ProviderPaymentResponseStatus } from 'config/types/order.type';
import { StorePaymentResponse } from 'store/models/order.model';

const initialState: StorePaymentResponse = {
  isFetching: false,
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    refreshConfirmPurchaseResponse: (state, action: PayloadAction<ConfirmPurchaseResponse | undefined>) => {
      state.confirmPurchaseResponse = action.payload;
      return state;
    },
    refreshInitialProperties: (state, action: PayloadAction<InitPurchaseProperties>) => {
      state.initialProperties = action.payload;
      return state;
    },
    refreshPaymentProviderResult: (state, action: PayloadAction<ProviderPaymentResponseStatus>) => {
      state.providerResult = action.payload;
      return state;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    refreshPaymentStore: (state, action: PayloadAction<StorePaymentResponse>) => {
      state = { ...state, ...action.payload };
      return state;
    },
    resetPaymentStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state) => {
      state.isFetching = false;
    });
  },
});

export const PaymentSlice = paymentSlice.actions;
export default paymentSlice.reducer;
